export enum ActionTypes {
 GET_COMPANY_SETTINGS = '[GET_COMPANY_SETTINGS] Get company settings',
 GET_COMPANY_SETTINGS_SUCCESS = '[GET_COMPANY_SETTINGS] Get company settings success',
 GET_COMPANY_SETTINGS_FAILURE = '[GET_COMPANY_SETTINGS] Get company settings failure',
}
